import React, { createContext, useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Dashboard from "./components/Dashboard";
import Profile from "./components/Profile";
import UserTracking from "./components/UserTracking";

export const AuthContext = createContext();

const App = () => {
  const [user, setUser] = useState(null);
  const [profileData, setProfileData] = useState(() => {
    const saved = localStorage.getItem("profileData");
    return saved ? JSON.parse(saved) : null;
  });

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleProfileUpdate = (data) => {
    setProfileData(data);
    localStorage.setItem("profileData", JSON.stringify(data));
  };

  useEffect(() => {
    const saved = localStorage.getItem("profileData");
    if (saved) {
      setProfileData(JSON.parse(saved));
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, handleLogin, profileData, handleProfileUpdate }}>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={user ? <Dashboard profileData={profileData} /> : <Navigate to="/login" />} />
          <Route path="/profile" element={<Profile onProfileUpdate={handleProfileUpdate} />} />
          <Route path="/user-tracking" element={<UserTracking profileData={profileData} />} />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
};

export default App;
